import { ReactNode, useCallback } from 'react';
import { useToggle } from 'react-use';

import { HealthcareFacility } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import { TestableComponentProps } from '@dreryk/react-components';

import { HealthcareBasicData } from '../../../common/HealthcareBasicData';
import { HealthcareTreeItemUpdateLink } from '../HealthcareTreeItemUpdateLink';

import { HealthcareFacilityUpdateModal } from './HealthcareFacilityUpdateModal';

type HealthcareFacilityUpdateLinkProps = TestableComponentProps & {
   readonly healthcareFacilityId: HealthcareFacility['id'];
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
   readonly label?: TranslatableText;
   readonly icon?: ReactNode;
};

export const HealthcareFacilityUpdateLink = (props: HealthcareFacilityUpdateLinkProps): JSX.Element => {
   const [showUpdateModal, toggleShowUpdateModal] = useToggle(false);

   const handleUpdateClick = useCallback(() => {
      toggleShowUpdateModal(true);
   }, [toggleShowUpdateModal]);

   const handleDataChanged = useCallback(() => {
      props.onDataChanged();
      toggleShowUpdateModal(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.onDataChanged, toggleShowUpdateModal]);

   return (
      <>
         <HealthcareTreeItemUpdateLink
            icon={props.icon}
            onClick={handleUpdateClick}
            testId={props.testId}
            label={props.label}
         />
         {showUpdateModal ? (
            <HealthcareFacilityUpdateModal
               healthcareFacilityId={props.healthcareFacilityId}
               healthcareParentData={props.healthcareParentData}
               onDataChanged={handleDataChanged}
               onCancel={toggleShowUpdateModal}
            />
         ) : null}
      </>
   );
};
